import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Shippings } from '@pages/checkout-app/types';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';
import { ManageProcessTimeDialogComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/process-time/manage-process-time-dialog/manage-process-time-dialog.component';

@Component({
  selector: 'checkout-process-time',
  templateUrl: './process-time.component.html',
  styleUrls: ['./process-time.component.scss'],
  standalone: false,
})
export class ProcessTimeComponent implements OnInit {
  @Input() shippings: Shippings[];
  @Input() checkoutSettings: CheckoutSettings;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  openProcessingTimeDialog(): void {
    this.dialog.open(ManageProcessTimeDialogComponent, {
      data: {
        shippings: this.shippings,
      },
    });
  }
}
